import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import { motion } from 'motion/react';
import ordinal from 'ordinal';
import { Fragment, useCallback } from 'react';
import { useSocketSend } from '../../context/webSocket/webSocketContext';
import { PanelItem } from '../../panels/panelItem';
import { PanelItemDivider } from '../../panels/panelItemDivider';
import { thunkShowPlayerInfo } from '../../redux/actions/playerInfoActions';
import { useAppDispatch } from '../../redux/store';
import { DEFAULT_BACKGROUND_DIVIDER_COLOR, DEFAULT_BACKGROUND_HOVER_COLOR, YELLOW_COLOR } from '../../styles/colors';
import { ALL_MEDAL_PROPERTIES, getImageUrlFromRank } from '../../types/medalProperties';
import { ALL_RANKING_PROPERTIES, getRankingTypeFromServerName } from '../../types/rankingsTypes';
import { getListRevealMotionProps } from '../../utils/motionUtils';
import { MedalDisplay } from '../medalDisplay';
import { OpenModalContainer } from '../openModalContainer';
const LIST_CSS = css `
  display: flex;
  flex-direction: column;
`;
const DESCRIPTION_CSS = css `
  padding-bottom: 20px;
`;
const ITEM_CSS = css `
  display: flex;
  flex-direction: row;
  gap: 0 10px;
`;
const PLACE_CSS = css `
  color: ${YELLOW_COLOR};
`;
const USERNAME_CSS = css `
  color: white;
`;
const VALUE_CSS = css `
  flex-grow: 1;
  text-align: end;
`;
/**
 * The description of the ranking actually comes from the corresponding medal.
 */
function getRankingDescription(medalType) {
    if (!medalType) {
        return;
    }
    return ALL_MEDAL_PROPERTIES[medalType].description;
}
export const RankingListModal = ({ onClose, rankingList }) => {
    const dispatch = useAppDispatch();
    const socketSend = useSocketSend();
    const onClickPlayer = useCallback((playerIdName) => {
        onClose();
        dispatch(thunkShowPlayerInfo(playerIdName, socketSend));
    }, [onClose, dispatch, socketSend]);
    const { rankedPlayers, rankingServerName } = rankingList;
    const rankingType = getRankingTypeFromServerName(rankingServerName);
    const medalType = rankingType ? ALL_RANKING_PROPERTIES[rankingType].medalType : undefined;
    const rankingDescription = getRankingDescription(medalType);
    const imageUrls = medalType ? ALL_MEDAL_PROPERTIES[medalType].rankedMedalImageUrls : undefined;
    const title = `${rankingType ? ALL_RANKING_PROPERTIES[rankingType].name : rankingServerName} Rankings`;
    return (_jsx(OpenModalContainer, { title: title, onClose: onClose, children: _jsxs(DialogContent, { children: [rankingDescription && _jsx(DialogContentText, { css: DESCRIPTION_CSS, children: rankingDescription }), _jsx(DialogContentText, { component: 'section', css: LIST_CSS, children: rankedPlayers.map((rankedPlayer, i) => {
                        const imageUrl = imageUrls ? getImageUrlFromRank(rankedPlayer.rank, imageUrls) : undefined;
                        const motionProps = getListRevealMotionProps(i, { startY: 40 });
                        return (_jsxs(Fragment, { children: [i > 0 && _jsx(PanelItemDivider, { color: DEFAULT_BACKGROUND_DIVIDER_COLOR, thicknessPx: 2 }), _jsxs(PanelItem, { onClick: () => onClickPlayer(rankedPlayer.playerIdName), hoverColor: DEFAULT_BACKGROUND_HOVER_COLOR, flexWrap: true, children: [_jsxs(motion.div, { css: ITEM_CSS, ...motionProps, children: [imageUrl && medalType && (_jsx(MedalDisplay, { medalName: ALL_MEDAL_PROPERTIES[medalType].name, imageUrl: imageUrl, sizePx: 24 })), _jsx("span", { css: PLACE_CSS, children: ordinal(rankedPlayer.rank) }), _jsx("span", { css: USERNAME_CSS, children: rankedPlayer.playerIdName.name })] }), _jsx(motion.div, { css: VALUE_CSS, ...motionProps, children: rankedPlayer.valueStr })] })] }, rankedPlayer.playerIdName.name));
                    }) })] }) }));
};
